<template>
<div class="modal fade" id="modalSaleEdit" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Plano.</h4>
      </div>

      <div class="modal-body">
        <form>
          <div class="form-group">
            <label>Quantos funcionários?</label>
            <input v-model="dataSaleEdit.totalEmployee" type="text" class="form-control" name="motive" required>
            <span v-if="error.totalEmployee" class="error-msg">{{error.totalEmployee}}</span>
          </div>

          <div class="form-group">
            <label>Valor MRR</label>
            <input v-model.lazy="mRRValue" v-money="money" type="text" class="form-control" id="value" name="value" required />
            <span v-if="error.mRRValue" class="error-msg">{{error.mRRValue}}</span>
          </div>

          <div class="form-group">
            <label>Observações</label>
            <textarea v-model="dataSaleEdit.notes" class="form-control" name="description"> </textarea>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button v-on:click="sendEdit()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="btn btn-register">
          <span v-if="!loadingChange">Enviar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  REPORT_SALE_UPDATE
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";
import {
  VMoney
} from 'v-money'

export default {
  name: "modalSaleEdit",
  props: ['objToModal'],
  directives: {
    money: VMoney
  },
  data() {
    return {
      price: 0,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      companyId: null,
      contextModal: null,
      error: {
        mRRValue: '',
        totalEmployee: ''
      },
      copyData: {},
      mRRValue: '',
      dataSaleEdit: {
        totalEmployee: '',
        notes: ''
      },
      emitValue: null,
      loadingChange: false
    }
  },
  watch: {
    objToModal: function (val) {
      this.companyId = val.company.companyId;
      this.contextModal = val.company.contentContext;

      this.copyData = val.company;
      this.dataSaleEdit = val.company;

      if (val.company.mrrValue.toString().includes('.')) {
        let auxValue = val.company.mrrValue.toString().split('.');
        if (auxValue[1].length === 1)
          this.mRRValue = val.company.mrrValue + '0';
        else
          this.mRRValue = val.company.mrrValue
      } else {
        this.mRRValue = val.company.mrrValue + ".00";
      }
    },
    emitValue: function (val) {
      this.$emit('update:reloadSale', val)
    }
  },
  methods: {
    closeModal() {
      $('#modalSaleEdit').modal('toggle');
    },
    sendEdit() {
      this.error.totalEmployee = "";
      this.error.mRRValue = "";
      this.error.notes = "";

      if (this.mRRValue !== 'R$ 0.00' && this.dataSaleEdit.totalEmployee && this.companyId) {
        if (!this.loadingChange) {
          this.loadingChange = true;
          delete this.dataSaleEdit.companyName;
          delete this.dataSaleEdit.createdAt;
          delete this.dataSaleEdit.startAt;
          delete this.dataSaleEdit.endAt;

          this.dataSaleEdit.mRRValue = this.mRRValue.replace("R$ ", "");

          UTIL_SERVICE.console("DATA SEND:", this.dataSaleEdit);
          REQUEST_SERVICE.requestContext('PUT', REPORT_SALE_UPDATE, this.contextModal, this.dataSaleEdit).then((response) => {
            UTIL_SERVICE.console("RESULT REPORT_SALE_UPDATE:", response);

            this.emitValue = Math.floor(Math.random() * 500);
            this.loadingChange = false;
            $('#modalSaleEdit').modal('toggle');

            ALERT_SERVICE.swal("Aviso", response.data, "success");
          }).catch((reason) => {
            this.loadingChange = false;
            $('#modalSaleEdit').modal('toggle');

            ALERT_SERVICE.showMsgError(reason.response.data.erros);
          });
        }
      } else {
        if (this.mRRValue === 'R$ 0.00')
          this.error.mRRValue = "Preencha um MRR.";

        if (!this.dataSaleEdit.totalEmployee)
          this.error.totalEmployee = "Preencha qtd de funcionários.";

        if (!this.companyId) {
          this.error.mRRValue = "CompanyID Inválido.";
          this.error.totalEmployee = "CompanyID Inválido.";
        }
      }
    }
  }
}
</script>

<style lang="scss">
#modalSaleEdit {
  .owner-select {
    width: 100%;

    select {
      border: 1px solid #999;
      border-radius: 5px;
      height: 34px;
      width: 100%;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .select-date {
    width: 100%;
    margin-top: 20px;

    p {
      font-size: 18px;
      padding-left: 1px;
    }

    .vdp-datepicker {
      display: inline-block;
      width: 100%;

      input {
        border: 1px solid #999;
        border-radius: 5px;
        height: 34px;
        width: 100%;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    i {
      display: inline-block;
      position: relative;
      right: 15px;
      top: -23px;
      float: right;
      color: #111;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalSaleEdit.vue